import React from 'react';
import LargeContainer from '@/components/front-office/containers/LargeContainer';

const CGV = () => {
  return (
    <LargeContainer>
      <div className="container mx-auto px-4 py-4 max-h-[60vh] overflow-y-auto">
        <h1 className="text-3xl font-bold mb-6">Conditions Générales de Vente</h1>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Article 1 - Objet</h2>
          <p className="mb-4">
            Les présentes Conditions Générales de Vente (CGV) régissent les relations contractuelles entre RIVKA TRAITEUR et le Client, définissant les droits et obligations de chaque partie dans le cadre de la vente de produits et services proposés par RIVKA TRAITEUR.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Article 2 - Produits et Services</h2>
          <p className="mb-4">
            Les produits et services offerts sont ceux qui figurent sur le site app.rivkatraiteur.com, sous réserve de leur disponibilité. Les photographies et descriptions des produits sont fournies à titre indicatif et n'ont pas de valeur contractuelle.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Article 3 - Prix</h2>
          <p className="mb-4">
            Les prix indiqués sur le site sont exprimés en euros (€) et toutes taxes comprises (TTC), sauf indication contraire. RIVKA TRAITEUR se réserve le droit de modifier ses prix à tout moment, mais s'engage à appliquer les tarifs en vigueur au moment de la validation de la commande par le Client. Les frais de livraison sont précisés dans le panier lors de la saisie de l'adresse de livraison et sont calculés en fonction du poids du colis.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Article 4 - Commande</h2>
          <p className="mb-4">
            <strong>4.1. Processus de Commande</strong><br />
            Le processus de commande sur le site comprend les étapes suivantes :<br />
            - Choix du Menu : Sélection du menu souhaité.<br />
            - Composition du Menu : Personnalisation des plats selon les préférences du Client.<br />
            - Ajout de Produits Supplémentaires : Possibilité d'ajouter des produits additionnels.<br />
            - Informations de Livraison et de Facturation : Saisie des coordonnées nécessaires.<br />
            - Paiement de la Commande : Règlement via notre partenaire de paiement System Pay.
          </p>
          <p className="mb-4">
            <strong>4.2. Validation de la Commande</strong><br />
            Le Client est tenu de vérifier attentivement les détails de sa commande avant validation. La confirmation de la commande se fait par e-mail. En cas d'erreur imputable au Client, RIVKA TRAITEUR se réserve le droit de ne pas échanger ni rembourser les produits concernés.
          </p>
          <p className="mb-4">
            <strong>4.3. Absence d'Acompte</strong><br />
            Aucun acompte n'est requis lors de la commande. Le paiement intégral est exigé au moment de la validation de la commande. En cas de non-paiement, la commande ne sera pas traitée.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Article 5 - Paiement</h2>
          <p className="mb-4">
            <strong>5.1. Modalités de Paiement</strong><br />
            Le règlement s'effectue par carte bancaire via le système sécurisé de notre partenaire System Pay. Les informations bancaires du Client sont cryptées et ne transitent pas par les serveurs de RIVKA TRAITEUR.
          </p>
          <p className="mb-4">
            <strong>5.2. Sécurisation</strong><br />
            Les coordonnées bancaires du Client sont protégées par le protocole SSL (Secure Socket Layer), garantissant une sécurité optimale lors des transactions.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Article 6 - Livraison</h2>
          <p className="mb-4">
            <strong>6.1. Zones de Livraison</strong><br />
            Les zones de livraison sont déterminées lors de la saisie de l'adresse de livraison. Si l'adresse indiquée n'est pas desservie, la commande ne pourra pas être validée.
          </p>
          <p className="mb-4">
            <strong>6.2. Frais de Livraison</strong><br />
            Les frais de livraison sont indiqués dans le panier au moment de la saisie de l'adresse de livraison. Ils sont calculés en fonction du poids du colis et peuvent être ajustés en conséquence.
          </p>
          <p className="mb-4">
            <strong>6.3. Partenaire de Livraison</strong><br />
            Les livraisons sont effectuées par notre partenaire Chronofresh, spécialisé dans le transport de produits alimentaires sous température dirigée.
          </p>
          <p className="mb-4">
            <strong>6.4. Délais de Livraison</strong><br />
            RIVKA TRAITEUR s'engage à respecter les délais de livraison indiqués lors de la commande. Toutefois, les délais de livraison sont exprimés à titre indicatif et en jours ouvrés.
          </p>
          <p className="mb-4">
            <strong>6.5. Responsabilité en Cas de Retard ou d'Erreur</strong><br />
            RIVKA TRAITEUR ne saurait être tenu responsable des retards ou erreurs imputables à Chronofresh. En cas de problème lors de la livraison, le Client est invité à contacter directement Chronofresh pour signaler le dysfonctionnement.
          </p>
          <p className="mb-4">
            <strong>6.6. Réception de la Commande</strong><br />
            Le Client est tenu de vérifier l'état des produits lors de la livraison et de signaler toute anomalie dans un délai de 24 heures au service client de RIVKA TRAITEUR.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Article 7 - Droit de Rétractation</h2>
          <p className="mb-4">
            Conformément à l'article L221-28 du Code de la consommation, le droit de rétractation ne peut être exercé pour les commandes de produits périssables, tels que les denrées alimentaires, fournies par RIVKA TRAITEUR.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Article 8 - Réclamations et Service Après-Vente</h2>
          <p className="mb-4">
            Pour toute réclamation, le Client peut contacter RIVKA TRAITEUR par e-mail à l'adresse rivkatraiteur@gmail.com ou par téléphone au +33 6 69 23 07 70 en demandant Nessim Maruani.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Article 9 - Responsabilité</h2>
          <p className="mb-4">
            RIVKA TRAITEUR ne saurait être tenu responsable des dommages résultant d'une mauvaise utilisation des produits livrés. La responsabilité de RIVKA TRAITEUR est systématiquement limitée à la valeur du produit mis en cause, déterminée à la date de sa vente.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Article 10 - Données Personnelles</h2>
          <p className="mb-4">
            Les informations collectées sont nécessaires à la gestion des commandes et aux relations commerciales. Elles sont traitées conformément à notre politique de confidentialité et en respect des dispositions du Règlement Général sur la Protection des Données (RGPD).
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Article 11 - Propriété Intellectuelle</h2>
          <p className="mb-4">
            Tous les éléments du site app.rivkatraiteur.com sont et restent la propriété intellectuelle et exclusive de RIVKA TRAITEUR. Nul n'est autorisé à reproduire, exploiter, rediffuser, ou utiliser à quelque titre que ce soit, même partiellement, des éléments du site sans autorisation préalable.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Article 12 - Modification des CGV</h2>
          <p className="mb-4">
            RIVKA TRAITEUR se réserve le droit de modifier les présentes CGV à tout moment. Les CGV applicables sont celles en vigueur à la date de la commande.
          </p>
        </section>
      </div>
    </LargeContainer>

  );
};

export default CGV; 